import React from "react";
import Ajax, { domain } from "../ajax/Ajax";
import { Helmet } from "react-helmet/es/Helmet";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";
import queryString from "query-string";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      invalidLogin: false,
      networkError: false,
      loginSuccess: false,
      processing: false,
      next: "",
    };

    this.submitLogin = this.submitLogin.bind(this);
  }

  async submitLogin(event) {
    event.preventDefault();
    this.setState({ processing: true });

    let data = {
      username: this.state.username,
      password: this.state.password,
    };
    let response = await Ajax.postData(
      domain + "/en/api/accounts/v1/token-auth/",
      data
    );

    if (response) {
      if (!response.ok) {
        this.setState({
          invalidLogin: true,
          processing: false,
        });
        return;
      }

      localStorage.setItem("token", response["token"]);
      localStorage.setItem("user", JSON.stringify(response["user"]));

      await this.setState({ processing: false, loginSuccess: true });
      let next = this.state.next;

      setTimeout(function () {
        if (next) {
          window.location.assign(next);
        } else {
          window.location.assign("/myshop/home/");
        }
      }, 2000);
    } else {
      this.setState({
        networkError: true,
        processing: false,
      });
    }
  }

  componentDidMount() {
    if (localStorage.getItem("token")) {
      try {
        this.props.history.push("/myshop/home/");
      } catch (e) {
        window.location.assign("/myshop/home/");
      }
    }

    try {
      let next = "";
      let params = queryString.parse(this.props.location.search);
      if (params) {
        if (params.next) {
          next = params.next;
          Object.keys(params).forEach((key) => {
            if (key !== "" && key !== "next") {
              next += "&" + key + "=" + params[key];
            }
          });
        }
      }

      this.setState({ next: next });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    let processing = "";
    if (this.state.processing) {
      processing = "is-loading";
    }

    return (
      <section className="animated fadeIn">
        <Helmet>
          <link rel="icon" href={logo} />
          <title>Login | VehShop</title>
        </Helmet>
        <div className="signup d-flex justify-content-center align-items-center">
          <div className="">
            <div className="has-text-centered title">
              <div>Login</div>
            </div>
            <div className="card is-shadowless signup-card">
              <div className="card-content">
                <form onSubmit={this.submitLogin} action="#">
                  {this.state.invalidLogin ? (
                    <div className="message is-danger animated fadeIn">
                      <div className="message-body has-text-centered">
                        <span className="zmdi zmdi-close-circle mr-2"></span>{" "}
                        Wrong username or password!
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {this.state.networkError ? (
                    <div className="message is-danger animated fadeIn">
                      <div className="message-body has-text-centered">
                        <span className="zmdi zmdi-close-circle mr-2"></span>{" "}
                        Network Error Please Try again!
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {this.state.loginSuccess ? (
                    <div className="message is-success animated fadeIn">
                      <div className="message-body has-text-centered">
                        <span className="zmdi zmdi-check-circle mr-2"></span>{" "}
                        Login Successful!
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <div className="field">
                    <label htmlFor="" className="label">
                      Email
                    </label>
                    <div className="control has-icons-left">
                      <input
                        onChange={(event) => {
                          this.setState({
                            username: event.target.value,
                            invalidLogin: false,
                          });
                        }}
                        value={this.state.username}
                        id="login-email"
                        type="text"
                        placeholder="e.g. name@vehmail.com"
                        className="input"
                        required
                      />
                      <span className="icon is-small is-left">
                        <i className="fa fa-envelope"></i>
                      </span>
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="" className="label">
                      Password
                    </label>
                    <div className="control has-icons-left">
                      <input
                        onChange={(event) => {
                          this.setState({
                            password: event.target.value,
                            invalidLogin: false,
                          });
                        }}
                        value={this.state.password}
                        id="login-password"
                        type="password"
                        placeholder="*******"
                        className="input"
                        required
                      />
                      <span className="icon is-small is-left">
                        <i className="fa fa-lock"></i>
                      </span>
                    </div>
                  </div>

                  <div className="field">
                    <button
                      className={"button is-info is-fullwidth " + processing}
                      disabled={this.state.processing}
                    >
                      Login
                    </button>
                  </div>

                  <div className="field">
                    <span>Don't have an Account? </span>
                    <span>
                      <Link to="/signup/">Signup</Link>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Login;
